import { useCallback } from 'react';
import { useResetPasswordMutation } from 'graphql/types';
import { AUTH_TOKEN } from 'constant';
import LocalStore from 'helpers/localStore';
import { ResetPassword } from 'services/auth';
import { message } from 'antd';

function useResetPassword() {
  const [userResetPass, { loading }] = useResetPasswordMutation();
  const login = useCallback(
    async (data: ResetPassword, onSuccess: () => void = () => {}) => {
      try {
        await userResetPass({
          variables: data,
        });
        onSuccess();
      } catch (err) {
        LocalStore.remove(AUTH_TOKEN);
        if (err instanceof Error) {
          message.error(err.message);
        }
      }
    },
    [userResetPass],
  );
  return [loading, login] as const;
}

export default useResetPassword;
